import { lazy } from 'react'
export const VendorPage = lazy(() => import('./list-vendor'))
